module.exports = __webpack_public_path__ + "static/media/Pokemol__Logo.d4f1d205.png";